import i18nLib, { InitOptions } from 'i18next';
import dayjs from 'dayjs';
import LanguageDetector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import * as english from '~admin/i18n/english.json';
import { Language } from '~common/i18n';

interface Translation {
  [locale: string]: any;
}

interface TranslationResource {
  [key: string]: Translation;
}

//TODO: Move to common

/**
 * Locale enum - not trimmed
 */
export enum Locale {
  ENGLISH_US = 'en-US',
  ENGLISH_CA = 'en-CA',
  FRENCH_CA = 'fr-CA',
  SPANISH_US = 'es-US',
}

/**
 * Returns an array of supported locales
 */
export const supportedLocales: Locale[] = [Locale.ENGLISH_US, Locale.ENGLISH_CA, Locale.FRENCH_CA];

/**
 * Returns an array of supported languages
 */
export const supportedLanguages: Language[] = [Language.ENGLISH, Language.FRENCH, Language.SPANISH];

const buildResourcesConfig = (translations: Translation): TranslationResource => {
  const resources: TranslationResource = {};
  Object.keys(translations).forEach((locale) => {
    resources[locale] = {
      translations: translations[locale],
    };
  });
  return resources;
};

/**
 * Removes the country code in a locale
 * In other words, it removes everything after "-" and keep only the 2 letter locale
 * i.e. 'en-US' will become 'en'
 * @param locale
 */
const getLanguageFromLocale = (locale: string): Language => {
  if (locale) {
    const index = locale.indexOf('-');
    if (index > 0) {
      return locale.substring(0, index) as Language;
    }
    return locale as Language;
  }
  return locale as Language;
};

export const createI18nInitConfig = (translations: Translation): InitOptions => {
  return {
    fallbackLng: Language.ENGLISH,
    ns: ['translations'],
    defaultNS: 'translations',
    resources: buildResourcesConfig(translations),
    interpolation: {
      escapeValue: false,
      format: (value: any): string => value,
    },
    nonExplicitWhitelist: true,
    whitelist: supportedLanguages,
    react: {
      wait: false,
    },
    detection: {
      order: ['cookie', 'localStorage', 'navigator', 'htmlTag', 'path'],
      lookupLocalStorage: 'userLocale',
      excludeCacheFor: supportedLocales,
    },
  };
};

export const i18n = i18nLib;

export const initializeI18N = (): void => {
  i18nLib
    .use(LanguageDetector)
    .use(initReactI18next)
    .init(
      createI18nInitConfig({
        en: english,
      }),
    )
    .then(() => {
      dayjs.locale(getLanguageFromLocale(i18n.language));
    });
};



// WEBPACK FOOTER //
// ./i18n/index.ts